(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dara-showroom"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dara-collection-story')){
class DaraCollectionFlow extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();const signal=this.controller.signal;
this.scenes=[...this.querySelectorAll('[data-story-scene]')];this.mobile=matchMedia('(max-width:749px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.frame=0;this.visible=new Set(this.scenes);
this.schedule=()=>{if(!this.enabled||this.frame||!this.visible.size)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.render();});};
this.measure=()=>{this.viewport=window.innerHeight;this.bounds=this.scenes.map(scene=>{const rect=scene.getBoundingClientRect();return{top:rect.top+window.scrollY,height:rect.height};});this.schedule();};
this.configure=()=>{this.enabled=this.mobile.matches&&!this.reduced.matches;if(!this.enabled)this.scenes.forEach(scene=>scene.removeAttribute('style'));this.measure();};
this.mobile.addEventListener('change',this.configure,{signal});this.reduced.addEventListener('change',this.configure,{signal});window.addEventListener('scroll',this.schedule,{passive:true,signal});window.addEventListener('resize',this.measure,{passive:true,signal});
this.resizeObserver=new ResizeObserver(this.measure);this.resizeObserver.observe(this);this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>entry.isIntersecting?this.visible.add(entry.target):this.visible.delete(entry.target));this.schedule();},{rootMargin:'30% 0px'});this.scenes.forEach(scene=>this.observer.observe(scene));this.configure();
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);}
render(){const scroll=window.scrollY;this.scenes.forEach((scene,index)=>{if(!this.visible.has(scene))return;const bounds=this.bounds[index];const progress=Math.min(1,Math.max(0,(scroll+this.viewport-bounds.top)/(this.viewport+bounds.height)));const ease=progress*progress*(3-2*progress);scene.style.setProperty('--flow-y',(ease-.5)*12+'px');scene.style.setProperty('--flow-scale',1.035+(1-ease)*.012);scene.style.setProperty('--flow-copy-y',(ease-.5)*-5+'px');});}
}
customElements.define('dara-collection-story',DaraCollectionFlow);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
